<template>
  <svg :fill="color" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.63,0c5.58,0,10.74,2.98,13.53,7.81,2.79,4.84,2.79,10.79,0,15.63-2.79,4.84-7.95,7.81-13.53,7.81s-10.74-2.98-13.53-7.81C-.7,18.61-.7,12.65,2.09,7.81,4.89,2.98,10.04,0,15.63,0ZM14.16,7.33v8.3c0,.49.24.95.65,1.22l5.86,3.91c.67.45,1.58.27,2.03-.41s.27-1.58-.41-2.03l-5.21-3.47v-7.52c0-.81-.65-1.47-1.47-1.47s-1.47.65-1.47,1.47Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconClock',
  props: {
    color: {
      type: String,
      default: '#24b9ec'
    }
  }
}
</script>
